<template>
	<div>
		<div class="message-bubble">
			<p>Por favor indicanos tu ubicación</p>
			<p>
				Arrastra y selecciona tu ubicación en el mapa
			</p>
			<div style="height: 300px; width: 100%">
				<l-map
					:zoom="zoom"
					:center="center"
					:options="mapOptions"
					style="height: 100%"
					@click="setMarker"
					@update:center="centerUpdate"
					@update:zoom="zoomUpdate"
				>
					<l-tile-layer :url="url" />
					<l-marker :lat-lng="marker">
						<l-popup>
							<div>
								Tu ubicación
							</div>
						</l-popup>
					</l-marker>
				</l-map>
			</div>
		</div>
	</div>
</template>

<script>
import { latLng } from "leaflet";
import { LMap, LTileLayer, LMarker, LPopup } from "vue2-leaflet";
import "leaflet/dist/leaflet.css";
import { Icon } from "leaflet";

delete Icon.Default.prototype._getIconUrl;
Icon.Default.mergeOptions({
	iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
	iconUrl: require("leaflet/dist/images/marker-icon.png"),
	shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});

export default {
	name: "Example",
	components: {
		LMap,
		LTileLayer,
		LMarker,
		LPopup,
	},
	data() {
		return {
			zoom: 16,
			url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
			showParagraph: false,
			mapOptions: {
				zoomSnap: 0.5,
			},
			showMap: true,
			marker: latLng(
				this.$store.getters["chatStore/get_store_data"].latitude,
				this.$store.getters["chatStore/get_store_data"].longitude
			),
		};
	},
	computed: {
		center() {
			const { latitude, longitude } = this.$store.getters[
				"chatStore/get_store_data"
			];
			return latLng(latitude, longitude);
		},
		store() {
			return this.$store.getters["chatStore/get_store_data"];
		},
	},
	mounted() {
		window.dispatchEvent(new Event("resize"));
	},
	methods: {
		setMarker(event) {
			this.marker = event.latlng;
			this.$store.dispatch("chatStore/get_client_location", event.latlng);
		},
		zoomUpdate(zoom) {
			this.currentZoom = zoom;
		},
		centerUpdate(center) {
			this.currentCenter = center;
		},
		showLongText() {
			this.showParagraph = !this.showParagraph;
		},
	},
};
</script>
